import { Box, Button, Stack, TextField, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ElementType } from "react";

interface VerifyEmailProps {
    email?: string;
    verifyEmail: (email: string, verificationCode: string) => void;
}

const VerifyEmail: ElementType<VerifyEmailProps> = ({ email, verifyEmail }) => {
    const navigate = useNavigate();

    const handleVerifyEmail = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!email) {
            return;
        }

        const data = new FormData(event.currentTarget);
        const verificationCode = data.get('verificationCode') as string;

        await verifyEmail(email, verificationCode);
        navigate('/signin');
    };

    const handleResendCode = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        console.log('Resend code');
    };

    return (
        <Box sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Typography component="h1" variant="h5">
                Verify
            </Typography>
            <Box
                component="form"
                noValidate
                onSubmit={handleVerifyEmail}
                display="flex" 
                flexDirection="column"
                width="100%"
                marginTop={3} >
                <TextField
                    autoComplete="verification-code"
                    name="verificationCode"
                    required
                    id="verificationCode"
                    label="Verification Code"
                    autoFocus
                />
                <Button
                    type="submit"
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Verify
                </Button>
                <Stack spacing={1}>
                    <Link 
                        href={"/signup"} 
                        variant="body2"
                        onClick={handleResendCode}
                        sx={{ cursor: 'pointer' }}
                    >
                        {'Don\'t have a verification code? Request a new one'}
                    </Link>
                </Stack>
            </Box>
        </Box>
    );
}

export default VerifyEmail;
